import { render, staticRenderFns } from "./MyVideo.vue?vue&type=template&id=267d2be9&"
import script from "./MyVideo.vue?vue&type=script&lang=js&"
export * from "./MyVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports